import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

/**
 * Upload an image to Bunny.net Storage
 * @param {File} file - Image file to upload
 * @param {string} folder - Folder path (e.g., 'images/hero')
 * @returns {Promise} Upload result with CDN URL
 */
export const uploadImage = async (file, folder = 'images') => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(
      `${API_URL}/api/images/upload?folder=${folder}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          // You can emit this to a progress callback if needed
          console.log(`Upload progress: ${percentCompleted}%`);
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Upload error:', error);
    throw error.response?.data || error;
  }
};

/**
 * Get image suggestions by category
 * @param {string} category - Category name (services, projects, etc.)
 * @returns {Promise} List of suggested images
 */
export const getImageSuggestions = async (category) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/images/suggestions?category=${category}`
    );
    return response.data;
  } catch (error) {
    console.error('Suggestions error:', error);
    throw error.response?.data || error;
  }
};

/**
 * List images from Bunny.net library
 * @param {string} folder - Folder to list
 * @returns {Promise} List of images
 */
export const listImages = async (folder = 'images') => {
  try {
    const response = await axios.get(
      `${API_URL}/api/images/library?folder=${folder}`
    );
    return response.data;
  } catch (error) {
    console.error('List images error:', error);
    throw error.response?.data || error;
  }
};

/**
 * Delete an image from Bunny.net Storage
 * @param {string} filePath - Path of the file to delete
 * @returns {Promise} Deletion result
 */
export const deleteImage = async (filePath) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/images/${filePath}`
    );
    return response.data;
  } catch (error) {
    console.error('Delete error:', error);
    throw error.response?.data || error;
  }
};
